import React, { useState, useEffect } from 'react';
import './Snackbar.css'; // Create a CSS file for styling

import {Check,X} from 'lucide-react';
const Snackbar = ({ message, color,onClose }) => {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    // Trigger the animation after a delay (e.g., 500ms)
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 100);
 
    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
 
  useEffect(() => {
    setVisible(true);

    // Hide snackbar after 3 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClick = () => {
    setVisible(false);
    onClose();
  };

  return ( <div className={`selectThumbImgOuterAll ${visible ? 'show' : ''}`}   style={{zIndex:999999999} }>
   
    <div className={`snackbar ${visible ? 'show' : ''}`} style={{"textAlign":"center",
        
        opacity: animate ? 1 : 0,
         background:"#fff",
       
        color:color,
        transition: 'bottom 1s ease, opacity 1s ease',
      }} onClick={handleClick}>
<div align="center" style={{padding:"15px",margin:"10px"}}>
<Check size={60}  color={color}/>
</div>
         
      {message}
    </div>
 
    </div>
  );
};

export default Snackbar;
